<section class="card workflow-step__card" data-test-id="signatureCardContainer">
  <form
    class="workflow-step__card__body"
    data-test-id="signatureCardBody"
    [formGroup]="formGroup"
  >
    @for (signature of signatures; track signature; let i = $index) {
      <div class="signature__section">
        <header
          class="workflow-step__card__header"
          [attr.data-test-id]="'signatureCardHeader_' + i"
        >
          <div class="u-fillRemaining">
            <h6 class="t-bold" [attr.data-test-id]="'signatureCardLabel_' + i">
              {{ signature.label }}
            </h6>
          </div>
        </header>
        <section>
          <form-group
            [attr.data-test-id]="'signatureCardFormGroup_' + i"
            [configs]="signature.controls"
            [form]="signatureForm.at(i)"
          ></form-group>
          @if (signature.attestation) {
            <input
              type="checkbox"
              required
              [formControlName]="'signature' + i"
              class="form-control form-control--checkbox"
              [attr.data-test-id]="'signatureCardAttestationCheckbox_' + i"
            />
          }
          <p
            class="t-data"
            [attr.data-test-id]="'signatureCardAttestation_' + i"
          >
            {{ signature.attestation }}
          </p>
        </section>
      </div>
    }
  </form>
</section>
